module.exports = __webpack_public_path__ + "static/media/design.286fd4be.svg";